import produce from 'immer'
import { ToppagespressAction, ToppagespressActionTypes } from '../actions/toppagespressActions'
import { ApiStatus, IToppagespressItem } from '../models'

export const initialToppagespressState: IToppagespressState = {
  loadingStatus: ApiStatus.NOTLOADED,
  addingStatus: ApiStatus.NOTLOADED,
  searchingStatus: ApiStatus.NOTLOADED,
  searchString: '',
  toppagespress: [],
  foundtoppagespress: [],
  totalDocs: 0,
  errMessage: '',
  errStatus: null,
  errField: null,
}

export default function toppagespressReducer(state: IToppagespressState = initialToppagespressState, action: ToppagespressAction) {
  return produce(state, (draft) => {
    switch (action.type) {
      case ToppagespressActionTypes.SEARCH_TOPPAGESPRESS:
        draft.searchString = action.searchOptions.searchString
        break
      case ToppagespressActionTypes.SEARCHING_TOPPAGESPRESS:
        draft.searchingStatus = ApiStatus.LOADING
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.NOTLOADED
        break

      case ToppagespressActionTypes.SEARCHING_TOPPAGESPRESS_FAILED:
        draft.searchingStatus = ApiStatus.FAILED
        break

      case ToppagespressActionTypes.FOUND_TOPPAGESPRESS:
        draft.searchingStatus = ApiStatus.LOADED
        action.keep
          ? draft.foundtoppagespress.push(...action.payload.toppagespress.docs)
          : (draft.foundtoppagespress = action.payload.toppagespress.docs)
        draft.totalDocs = action.payload.toppagespress.totalDocs
        break

      case ToppagespressActionTypes.LOAD_TOPPAGESPRESS:
      case ToppagespressActionTypes.LOADING_TOPPAGESPRESS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.NOTLOADED
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.foundtoppagespress = []
        break

      case ToppagespressActionTypes.LOADING_TOPPAGESPRESS_FAILED:
        draft.loadingStatus = ApiStatus.FAILED
        break

      case ToppagespressActionTypes.LOADED_TOPPAGESPRESS:
        draft.loadingStatus = ApiStatus.LOADED
        draft.toppagespress = action.payload.toppagespress.docs
        draft.totalDocs = action.payload.toppagespress.totalDocs
        break

      case ToppagespressActionTypes.ADD_TOPPAGESPRESS:
      case ToppagespressActionTypes.ADDING_TOPPAGESPRESS:
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.errMessage = ''
        draft.errStatus = null
        draft.errField = null
        break

      case ToppagespressActionTypes.ADDING_TOPPAGESPRESS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case ToppagespressActionTypes.ADDED_TOPPAGESPRESS:
        draft.addingStatus = ApiStatus.LOADED
        draft.errStatus = 200
        draft.toppagespress.push(action.payload.toppagespress.docs[0])
        if (draft.searchString) draft.foundtoppagespress.push(action.payload.toppagespress.docs[0])
        break

      case ToppagespressActionTypes.REMOVE_TOPPAGEPRESS:
        draft.toppagespress.splice(
          draft.toppagespress.findIndex((toppagepress) => toppagepress._id === action.payload._id),
          1
        )
        break

      case ToppagespressActionTypes.SOFT_REMOVE_TOPPAGESPRESS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        break

      case ToppagespressActionTypes.SOFT_REMOVING_TOPPAGESPRESS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case ToppagespressActionTypes.SOFT_REMOVED_TOPPAGESPRESS:
        draft.addingStatus = ApiStatus.LOADED
        draft.toppagespress.splice(
          draft.toppagespress.findIndex((toppagepress) => toppagepress._id === action.payload._id),
          1
        )
        break

      case ToppagespressActionTypes.SOFT_REMOVING_TOPPAGESPRESS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case ToppagespressActionTypes.EDIT_TOPPAGESPRESS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        break

      case ToppagespressActionTypes.EDITING_TOPPAGESPRESS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case ToppagespressActionTypes.EDITED_TOPPAGESPRESS:
        draft.addingStatus = ApiStatus.LOADED
        draft.toppagespress[draft.toppagespress.findIndex((toppagepress) => toppagepress._id === action.payload._id)] = action.payload
        draft.foundtoppagespress[draft.foundtoppagespress.findIndex((toppagepress) => toppagepress._id === action.payload._id)] = action.payload
        break

      case ToppagespressActionTypes.EDITING_TOPPAGESPRESS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break
    }
  })
}

export interface IToppagespressState {
  loadingStatus: ApiStatus
  addingStatus: ApiStatus
  searchingStatus: ApiStatus
  searchString: string
  toppagespress: IToppagespressItem[]
  foundtoppagespress: IToppagespressItem[]
  totalDocs: number
  errMessage?: string
  errStatus?: number
  errField?: string
}
